export const ROUTES = {
  home: "/",
  session: "/session",
  stats: "/stats",
  settings: "/settings",
} as const;
